import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: [
        {
            Title: () => <>Doi Inthanon National Park</>,
            Location: () => <>Doi Inthanon National Park</>,
            locationLink:
                "https://www.thainationalparks.com/doi-inthanon-national-park",
            Address: () => (
                <>
                </>
            ),
            link:
                "https://www.thainationalparks.com/doi-inthanon-national-park",
            Details: () => (
                <>
                    <p>
                        Doi Inthanon is the highest mountain in Thailand and it takes about 2 hours to get
                        there from downtown Chiang Mai.  There are several hiking trails within the park,
                        but they are not connected.  People typically have a car or bike to travel
                        between the hiking trails as they are far apart and are only connected by the road.
                        There is no trail to the summit, but the road can take you to a parking area that is
                        a couple hundred meters from the summit. 
                    </p>
                </>
            ),
        },
        {
            Title: () => <>Buatong Waterfall</>,
            Location: () => <>Vans to leave from Kaomai Lanna or your downtown hotel if you provide the location on the RSVP form</>,
            locationLink:
                "https://itsbetterinthailand.com/activities/sticky-waterfall-chiang-mai/",
            Address: () => (
                <>
                </>
            ),
            link:
                "https://itsbetterinthailand.com/activities/sticky-waterfall-chiang-mai/",
            Details: () => (
                <>
                    <p>
                        Buatong Waterfall known as "Sticky Waterfall" by Westerners is a unique
                        waterfall that's possible to climb up by foot.  Limestone deposits from the
                        mineral rich water gives texture to the rocks and allows for visitors to
                        have the unique experience of climbing a waterfall by foot.  Watch out for
                        the green rocks because those ones have algae growth and could be slippery.
                        It takes about one hour to get to Buatong Waterfall by car. 
                    </p>
                </>
            ),
        },
    ],
    [LANGUAGE.ZH]: [
        {
            Title: () => <>因他暖山</>,
            Location: () => <>因他暖山</>,
            locationLink:
                "https://www.thainationalparks.com/doi-inthanon-national-park",
            Address: () => (
                <>
                </>
            ),
            link:
                "https://www.thainationalparks.com/doi-inthanon-national-park",
            Details: () => (
                <>
                    <p>
                        泰国的因他暖山是泰国最高的山峰，从市中心出发需要大约两小时的车程。公园内有多条徒步路线，但彼此不相连。由于这些步道相距较远，且仅由公路连接，人们通常需要开车或骑车在不同步道之间穿梭。虽然没有直达山顶的步道，但可以驾车到达一个距离山顶仅数百米的停车场。
                    </p>
                </>
            ),
        },
        {
            Title: () => <>鲍东瀑布（Buatong Waterfall）</>,
            Location: () => <>鲍东瀑布（Buatong Waterfall）</>,
            locationLink:
                "https://itsbetterinthailand.com/activities/sticky-waterfall-chiang-mai/",
            Address: () => (
                <>
                </>
            ),
            link:
                "https://itsbetterinthailand.com/activities/sticky-waterfall-chiang-mai/",
            Details: () => (
                <>
                    <p>
                        鲍东瀑布（Buatong Waterfall），因其独特的岩石质地，被游客们称为“黏黏瀑布”（Sticky Waterfall）。富含矿物质的水流沉积了石灰岩，使得岩石表面变得粗糙，游客可以体验徒步攀爬瀑布的独特乐趣。请注意避开绿色的岩石，因为上面长有藻类，可能会比较滑。从市区开车到鲍东瀑布大约需要一小时。
                    </p>
                </>
            ),
        },
    ],
}
